/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Appointment Notification View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './ScheduledAppointmentsView';

export const mapStateToPropsScheduledAppointments = mapStateToProps;
export const mapDispatchToPropsScheduledAppointments = mapDispatchToProps;

export default connect(
  mapStateToPropsScheduledAppointments,
  mapDispatchToPropsScheduledAppointments
)(View);
